import React, {Component} from 'react';
import {authService} from '../services/auth';
import {Redirect} from "react-router-dom";
import { authHelpers } from '../helpers/auth';

import {Container, Row, Col} from 'reactstrap';
import {Button, Form, FormGroup, Label, Input, Alert} from 'reactstrap';
import classnames from 'classnames';

import Logo from "../../core/components/Logo";
import { utils } from "../../core/helpers/utils";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginSuccessful: !!authHelpers.getAuthCookie()
        };
        this.login = this.login.bind(this);
        this.resetFields = this.resetFields.bind(this);
    }

    login(e) {
        e.preventDefault();
        authService.login(this.state.email, this.state.password)
            .then(result => {
                const response = utils.parsePayload(result);
                if (response.success) { //Show success alert and redirect to login.
                    authHelpers.setAuthCookie(true, 1);
                    this.setState({successMessage: response.message});
                    this.setState({loginSuccessful: true});
                } else { //Show error alert.
                    this.setState({errorMessage: response.message}, () => {
                        this.resetFields(response.field);
                    });
                }
            });
    }

    resetFields() {
        this.setState({email: '', password: ''});
    }

    render() {
        if (this.state.loginSuccessful) {
            return <Redirect to={{pathname: '/biddeasy-dashboard'}}/>;
        }

        return (
            <div className="bg-light h-100">
                <Container fluid className="unauthenticated-header">
                    <Row className="justify-content-center">
                        <Col xs="10">
                            <Logo/>
                        </Col>
                    </Row>
                </Container>

                <Container className="login-container pt-5">
                    <Row className="justify-content-center">
                        <Col xs="12" md="5" lg="4">
                            <h2 className="font-weight-semi-bold font-size-triple">
                                Login
                            </h2>
                        </Col>

                        <Col xs="12" md="5" lg="4">
                            <Row>
                                <Col xs="12">
                                    <Alert color="success"
                                           className={classnames('display', {hide: !this.state.success})}>
                                        {this.state.successMessage}
                                    </Alert>

                                    <Alert color="danger"
                                           className={classnames('display', {hide: !this.state.errorMessage})}>
                                        {this.state.errorMessage}
                                    </Alert>
                                </Col>
                            </Row>

                            <Form className="login-form" onSubmit={(e)=> this.login(e)}>
                                <FormGroup>
                                    <Label for="email"
                                           className={classnames('text-muted', 'font-size-tiny', {invisible: !this.state.email})}>
                                        Email
                                    </Label>

                                    <Input type="email"
                                           name="email"
                                           id="email"
                                           className="form-control font-weight-semi-bold"
                                           placeholder="Email"
                                           onChange={e => this.setState({email: e.target.value})}
                                           value={this.state.email}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="password"
                                           className={classnames('text-muted', 'font-size-tiny', {invisible: !this.state.password})}>
                                        Password
                                    </Label>

                                    <Input type="password"
                                           name="password"
                                           id="password"
                                           className="form-control font-weight-semi-bold"
                                           placeholder="Password"
                                           onChange={e => this.setState({password: e.target.value})}
                                           value={this.state.password}
                                    />
                                </FormGroup>

                                <FormGroup className="cta-block">
                                    <Button color="primary">Login</Button>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Login;
